/**
 * Utility to detect and handle subdomain-based routing
 */

export const getSubdomain = () => {
  const hostname = window.location.hostname;
  
  // Handle localhost and IP addresses (no subdomain)
  if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return null;
  }

  // Optional dev-host support: `linguist.localhost` has only two parts, so
  // the length check below would return null. Map it to its first label.
  if (hostname.endsWith('.localhost')) {
    return hostname.split('.')[0];
  }

  // Split hostname into parts
  const parts = hostname.split('.');
  
  // If we have at least 3 parts (subdomain.domain.tld), extract subdomain
  if (parts.length >= 3) {
    return parts[0];
  }
  
  return null;
};

export const isCardsSubdomain = () => {
  const subdomain = getSubdomain();
  return subdomain === 'cards';
};

export const isVideosSubdomain = () => getSubdomain() === 'videos';

export const isAdminSubdomain = () => {
  const subdomain = getSubdomain();
  return subdomain === 'admin' || subdomain === null; // Default to admin for localhost
};

export const getFullDomain = () => {
  return window.location.hostname;
};

export const isLinguistSubdomain = () => getSubdomain() === 'linguist';

// Canonical in-app login path for the current host.
// linguist host  -> /login
// admin/dev host -> /linguist-login (unchanged legacy path)
export const getLinguistLoginPath = () =>
  isLinguistSubdomain() ? '/login' : '/linguist-login';

// Public URL used by admin UI / emails when pointing someone at the portal.
export const getLinguistLoginUrl = () => {
  const host = window.location.hostname;
  const isLocal =
    host === 'localhost' ||
    host === '127.0.0.1' ||
    /^\d+\.\d+\.\d+\.\d+$/.test(host);
  if (isLocal) return `${window.location.origin}/linguist-login`;
  return isLinguistSubdomain()
    ? `${window.location.origin}/login`
    : 'https://linguist.communicationessentialsllc.com/login';
};
